import React, { useState, useEffect, forwardRef } from 'react';
import './CopyableLabel.css';
import { ReactComponent as CopyIcon } from '../../../../assets/icon/feather-copy.svg';
import Button from '../Button/Button';


const CopyableLabel: React.FC<{ value: string, copyValue?: string }> = ({ value, copyValue = value }) => {
  const copyLabel = async () => {
    await navigator.clipboard.writeText(copyValue);
  }

  return (
    <div className="copyable-label-container" onClick={copyLabel}>
      <div className="label-container">{value}</div>
      <Button onClick={copyLabel} icon={<CopyIcon />} />
    </div>
  );
};

export default CopyableLabel;
